// Shared media-type/URL helpers used by the history page and history service.

export function isVideoMediaType(value = "") {
  const type = String(value || "").trim().toLowerCase();
  return type === "video" || type.startsWith("video/");
}

export function isLikelyVideoUrl(value = "") {
  const raw = String(value || "").trim();
  if (!raw) return false;
  let text = raw.toLowerCase();
  try {
    text = decodeURIComponent(new URL(raw, "https://inssa.us").pathname).toLowerCase();
  } catch {
    try {
      text = decodeURIComponent(raw).toLowerCase();
    } catch {
      text = raw.toLowerCase();
    }
  }
  if (/\.(jpe?g|png|gif|webp|avif|svg)(?:[?#]|$)/i.test(text)) return false;
  return /\.(mp4|mov|m4v|webm|avi|mkv)(?:[?#]|$)/i.test(text) || /(?:^|[/_-])video[_-]/i.test(text);
}
